<template>
  <div class="mx-auto p-3 mb-4 border">
    <p>
      Wenn es besonders schnell und anonym gehen soll, so haben Sie die
      Möglichkeit unkompliziert über Ihre Telefonrechnung zu bezahlen.
    </p>
    <p>
      Die Telefonanbieter erheben für uns leider hohe Gebühren bei dieser
      Bezahlungsmethode, daher bekommen Sie verhältnismäßig weniger
      {{ appCurrency }} als mit anderen Bezahlmehoden.
    </p>
    <span>
      Dieses Angebot ist nur in den Ländern: Deutschland, Österreich und der
      Schweiz möglich. Nur aus dem Festnetz - nicht mit einem Handy möglich
    </span>
  </div>
</template>

<script>
export default {
  computed: {
    appCurrency() {
      return Laravel.lang.currency;
    }
  }
};
</script>
